module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_library.js
 ** module id = 266
 ** module chunks = 2 4 6 8 9 11 12
 **/